export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function api(path, options = {}) {
  let response;
  try {
    response = await fetch(`${API}${path}`, {credentials: 'include', ...options,
      headers: {'Content-Type': 'application/json', ...options.headers}});
  } catch (_) {
    throw new Error('Unable to connect. Please try again.');
  }
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(typeof data.detail === 'string' ? data.detail : 'Something went wrong. Please try again.');
    error.status = response.status;
    throw error;
  }
  return data;
}